module.exports = __webpack_public_path__ + "static/media/info01_Validacion_de_correo.de8bbb85.png";